export default {
    'diagram3b1-5': {
        'checkboxes': {
            'title': 'Question:	',
            'checkbox-1': 'Why did it collapse?',
            'checkbox-2': 'How did it collapse?',
            'checkbox-3': 'How do you know it collapsed?',
        },
        'elements': {
            'one': 'When the Greco-Roman world collapsed, so did the tradition of classical sculpture',
            'two': 'Many of the subjects were unacceptably nude',
            'three': 'Many of the nudes were pagan gods and goddesses',
            'four': 'Envisioning a nude Christian god was unthinkable'
        },
        'checkboxes-bottom': {
            'title': 'General Plural Noun',
            'checkbox-1': 'Reasons',
            'checkbox-2': 'Steps',
            'checkbox-3': 'Proofs',
        },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b1/diagram5/i18n/en.js